import React, { useEffect, useRef } from "react";

const FAQPopup = ({ isOpen, closePopup }) => {
  const dialogRef = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (isOpen && !dialog.open) dialog.showModal();
    if (!isOpen && dialog.open) dialog.close();
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isOpen]);

  return (
    <dialog ref={dialogRef} className="faq-dialog" aria-labelledby="faq-title" onCancel={closePopup} onClose={closePopup}>
      <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
        <h2 id="faq-title" className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange text-center">Frequently Asked Questions</h2>
        
        <div className="max-h-96 overflow-y-auto space-y-6">
          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">1. What are the benefits of Reiki?</p>
            <ul className="list-disc pl-6 text-gray-600 font-karla">
              <li>Reducing stress and anxiety</li>
              <li>Relieving pain and tension</li>
              <li>Promoting emotional healing</li>
              <li>Improving sleep</li>
              <li>Boosting overall well-being</li>
            </ul>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">2. Is Reiki safe?</p>
            <p className="text-gray-600 font-karla">Yes, Reiki is completely safe. It is a gentle and non-invasive therapy. It’s suitable for everyone, including children, adults, and even pets.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">3. Do I need to believe in Reiki for it to work?</p>
            <p className="text-gray-600 font-karla">No, you don’t need to believe in Reiki for it to be effective. Reiki works whether or not you believe in it. It’s about energy, and everyone can benefit from it.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">4. Can I receive Reiki remotely (distant Reiki)?</p>
            <p className="text-gray-600 font-karla">Yes! Reiki can be sent across any distance. Remote Reiki works in the same way as in-person Reiki, with the practitioner sending healing energy to you from afar. Many people find it just as powerful as in-person sessions.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">5. How many sessions do I need?</p>
            <p className="text-gray-600 font-karla">The number of sessions depends on your needs and goals. Some people feel immediate relief after just one session, while others benefit from regular sessions over time. Your practitioner can help guide you based on your specific situation.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">6. Can Reiki replace medical treatment?</p>
            <p className="text-gray-600 font-karla">Reiki is not a substitute for medical treatment, but it can complement traditional medical care. Many people use Reiki alongside other treatments to help improve overall well-being and support recovery.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">7. How can I prepare for a Reiki session?</p>
            <p className="text-gray-600 font-karla">Simply relax and come with an open mind. Wear comfortable clothing and be ready to let go of stress. There’s no special preparation required.</p>
          </div>

          <div>
            <p className="font-semibold text-md text-gray-800 mb-1">8. How can I book a session?</p>
            <p className="text-gray-600 font-karla">You can book a session through my website or by contacting me directly at <a href="mailto:radiantlighthealing2024@gmail.com" className="text-blue-600">radiantlighthealing2024@gmail.com</a></p>
          </div>
        </div>

        <div className="mt-6 flex justify-around">
          <button
            onClick={closePopup}
            className="bg-about-me-orange text-white px-4 py-2 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default FAQPopup;
